import { createAction } from '@reduxjs/toolkit'

// tryGetAllGroups
export const getLatestJobRun = createAction('get_latest_job_run')
export const getLatestJobRunSuccess = createAction<{
  latest_job_run: string | null
}>('get_latest_job_run_success')
export const getLatestJobRunFailed = createAction('get_latest_job_run_failed')
